import { IconUserFilled } from '@zillow/constellation-icons';
import StringConstants from '../../../../constants/StringConstants';
import EmptyState from '../../../EmptyState';

export default function EmptyContainer() {
  return (
    <EmptyState
      icon={<IconUserFilled />}
      body={StringConstants.INBOX_SIDEBAR_EMPTY_HEADING}
      css={{ height: '100%', justifyContent: 'center', paddingInline: 'default' }}
    />
  );
}
